import styled from "styled-components";
import { Grid2 } from "@mui/material";
import { fonts } from "utils/theme";

export const Wrapper = styled(Grid2).attrs(() => ({
  container: true,
  spacing: 2,
}))`
  * {
    font-family: ${fonts.body} !important;
  }

  .MuiChartsLegend-mark {
    width: 12px;
    height: 12px;
    y: -6px;
    x: 4px;
  }

  .MuiBarLabel-root {
    fill: white;
  }
`;

export const Section = styled(Grid2)`
  position: relative;
`;

export const ChartWrapper = styled.div`
  position: relative;
`;

export const ChartUnderlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  opacity: 0.33;

  .MuiLineElement-root {
    stroke-dasharray: 4;
  }
`;

export const Options = styled.div`
  display: flex;
  gap: 16px;
`;
